import React, { useState } from 'react';
import styles from './styles.module.css';

/**
 * 検索ボックスコンポーネント。ボックス内で Enter を押下することで検索メソッドが実行される。
 * @param {Object} props
 * @param {Function} props.search - 検索メソッド
 * @returns {JSX.Element}
 */
const SearchBox = ({ search, placeholder }) => {
  const [input, setInput] = useState('');

  /**
   * 入力内容が空でなければ空白区切りで配列に変換したものを、空の場合は空配列を返す。
   * ダブルクォーテーションで囲われている場合は空白を含む文字列も一単語とみなす。
   * @returns {string[]|null}
   */
  const split = () => {
    if (!input) return [];
    const regex = /"([^"]*)"|([^ ]+)/g;
    const matches = input.match(regex);

    // マッチングした各要素でダブルクォーテーションがあれば削除
    return matches.map((match) => {
      if (match.startsWith('"') && match.endsWith('"')) {
        return match.slice(1, -1);
      }
      return match;
    });
  };

  /**
   * 配列に変換した入力内容を渡して検索メソッドを実行する。
   * Enter 以外の押下時は何もしない。
   */
  const handleKeyDown = (e) => {
    if (e.key !== 'Enter') return;
    search(split());
  };

  return (
    <div className={styles.searchArea}>
      <input
        className={styles.search}
        type='search'
        onChange={(e) => setInput(e.target.value)}
        value={input}
        placeholder={placeholder}
        onKeyDown={handleKeyDown}
      />
    </div>
  );
};

export default SearchBox;
